export default __webpack_public_path__ + "static/media/white-queen.0f8e5b56.png";